import React, { useEffect, useState } from "react";
import { Row, Col, Container, Input, Label, Spinner, Alert } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "components/VerticalLayout/Footer";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import { get } from "helpers/api_helper";
import { GET_VENDOR_BY_ID } from "constants/api_constants";
import { showErrorToast } from "helpers/toastMessages";

function ViewVendorShippingBilling() {
  const { vendorId } = useParams();
  const [vendorData, setVendorData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (vendorId) {
      fetchVendorData();
    } else {
      setApiError("Vendor ID is required");
      showErrorToast("Vendor ID is required");
    }
  }, [vendorId]);

  const fetchVendorData = async () => {
    setIsLoading(true);
    setApiError("");
    try {
      const response = await get(GET_VENDOR_BY_ID(vendorId));
      console.log("response",response);
      
      const vendData = response?.data?.data?.[0] || response?.data?.[0] || response;
      if (vendData) {
        setVendorData(vendData);
      } else {
        setApiError("No vendor data found");
        showErrorToast("No vendor data found");
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch vendor data";
      setApiError(errorMsg);
      showErrorToast(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const renderAddress = (address) => (
    <>
      <Row className="mb-3">
        <Label className="col-form-label">Country</Label>
        <Input
          type="text"
          value={address?.country || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      <Row className="mb-3">
        <Label className="col-form-label">Province</Label>
        <Input
          type="text"
          value={address?.province || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      <Row className="mb-3">
        <Label className="col-form-label">City</Label>
        <Input
          type="text"
          value={address?.city || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      <Row className="mb-3">
        <Label className="col-form-label">Zip Code</Label>
        <Input
          type="text"
          value={address?.zipCode || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      <Row className="mb-3">
        <Label className="col-form-label">Address</Label>
        <Input
          type="text"
          value={address?.street || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
    </>
  );

  return (
    <div className="page-content">
      <Container fluid style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading="Billing and Shipping Details"
          routePath="Home"
          pageName="Billing - Shipping"
        />
        {isLoading && (
          <div className="text-center my-3">
            <Spinner color="primary" />
          </div>
        )}
        {apiError && (
          <Alert color="danger" className="text-center my-3">
            {apiError}
            <button onClick={fetchVendorData} className="btn btn-link">
              Retry
            </button>
          </Alert>
        )}
        {!isLoading && !apiError && (
          <Row className="justify-content-around mt-3">
            <Col md={5}>
              <h6 className="text-primary">Billing Address</h6>
              {renderAddress(vendorData?.billingAddress)}
            </Col>
            <Col md={5}>
              <h6 className="text-primary">Shipping Address</h6>
              {renderAddress(vendorData?.shippingAddress)}
            </Col>
          </Row>
        )}
        <Footer
          saveText="Edit Billing/Shipping"
          save={() => navigate(`/add-vendor/${vendorId}`)}
          showBackConfirmation={false}
        />
      </Container>
    </div>
  );
}

export default ViewVendorShippingBilling;